import $ from 'jquery';

const initLoadMorePress = () => {
    var items = '#js-press .press-list__item';
    var i = 3;
    $(items).slice(0, 3).css('display', 'block');
    
    $('#loadMore').on('click', function (e) {
        $(items + ':hidden').slice(0, 3).css('display', 'block');
        
        i = i + 3;
        var itemsLenght = $(items).length;

        if (itemsLenght <= i) {
            $('#loadMore').hide();
        }
    });
};

export default initLoadMorePress;
